import './../mobileMenu/mobileMenuStyle.css'
import "./languageSelectorStyle.css"
import { useContext, useState } from "react";
import {SelectedLanguageContext} from '../../../../contexts/siteContentsContext'
import LanguageSelectorButton from "./subcomponents/LanguageSelectorButton";

export default function LanguageSelector() {
    const [ menuIsOpen, setMenuIsOpen] = useState(false);
    const {setSelectedLanguage} = useContext(SelectedLanguageContext);

    const languageSettings = 
        [
            {
                srcLanguageFile: "/siteData/contentPT-BR.json",
                srcIcon: "/languageIcons/brazil.png",
                name: "pt-br",
                nameCompletName: "Português",
                alt: "lingua selecionado - Português"
            },
            {
                srcLanguageFile: "/siteData/contentEN.json",
                srcIcon: "/languageIcons/usa.png",
                name: "en-us",
                nameCompletName: "English",
                alt: "language selected - English"
        }
    ];

    const [languageMenuIsOpen, setLanguageMenuIsOpen] = useState(false);
    var header = document.querySelector('header');
    var headerHeight;
    if (header) headerHeight = header.offsetHeight;

    const languageMobileDropMenu = {
        top: headerHeight
    }

    function handleLanguageSelection(language) {
        setSelectedLanguage(language)
        localStorage.setItem("languageSettings", JSON.stringify(language));
    }

    return(
        <div className="language-selector__container" onClick={() => setMenuIsOpen(!menuIsOpen)} hidden>
            {!menuIsOpen ?
                <LanguageSelectorButton />
            :
            <>
                <LanguageSelectorButton />
                <div className="navbar-anchor-buttons__mobile language-selector__buttons-area" style={headerHeight? languageMobileDropMenu : {}}>
                    {languageSettings.map( language => 
                        <img 
                            className="language-selector__button" 
                            src={language.srcIcon} 
                            onClick={() => handleLanguageSelection(language)}/>
                    )}
                </div>
            </>
            }
        </div>
    );
}